
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const DeleteIntegration = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'INTEGRATION_DELETE_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'INTEGRATION_DELETE_ERROR':
            return { loading: false, error: true, data: [] };
        case 'INTEGRATION_DELETE_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'INTEGRATION_DELETE_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default DeleteIntegration